export default function ({text}) {
    return (
        <div className="c-routedetail__no-comments">
            <div className="c-routedetail__no-comments__content">
                <i className="fa fa-person-hiking"></i>
                <p>{text}</p>
            </div>
        </div>
    )
    

}